import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71ab2c8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Detail Berita")
  ])
], -1))
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Sumber Berita", -1))
const _hoisted_7 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-sm-6 col-md-4 col-lg-3" }
const _hoisted_10 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "youtube_radio"
}
const _hoisted_11 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Youtube "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Youtube")
], -1))
const _hoisted_13 = { class: "col-12 col-sm-6 col-md-4 col-lg-3" }
const _hoisted_14 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "instagram_radio"
}
const _hoisted_15 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Instagram "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Instagram")
], -1))
const _hoisted_17 = { class: "col-12 col-sm-6 col-md-4 col-lg-3" }
const _hoisted_18 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "twitter_radio"
}
const _hoisted_19 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Twitter "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Twitter")
], -1))
const _hoisted_21 = { class: "col-12 col-sm-6 col-md-4 col-lg-3" }
const _hoisted_22 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "facebook"
}
const _hoisted_23 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Facebook "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Facebook")
], -1))
const _hoisted_25 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 mt-0 mt-sm-5" }
const _hoisted_26 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "tiktok"
}
const _hoisted_27 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Tiktok "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Tiktok")
], -1))
const _hoisted_29 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 mt-0 mt-sm-5" }
const _hoisted_30 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "linkedin"
}
const _hoisted_31 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Linkedin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Linkedin")
], -1))
const _hoisted_33 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 mt-0 mt-sm-5" }
const _hoisted_34 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "review"
}
const _hoisted_35 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Review Apps "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, " Media Sosial Review Apps ")
], -1))
const _hoisted_37 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 mt-0 mt-sm-5" }
const _hoisted_38 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "threads"
}
const _hoisted_39 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Threads "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, " Media Sosial Threads ")
], -1))
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "URL Berita", -1))
const _hoisted_45 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "input-group mb-3" }
const _hoisted_48 = {
  key: 0,
  class: "input-group-text text-muted"
}
const _hoisted_49 = {
  key: 1,
  class: "input-group-text text-muted"
}
const _hoisted_50 = {
  key: 2,
  class: "input-group-text text-muted"
}
const _hoisted_51 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Masukkan hanya ID berita dari URL", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "d-flex align-items-center" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1))
const _hoisted_57 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_58 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_59 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_60 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_61 = {
  key: 4,
  class: "text-muted"
}
const _hoisted_62 = {
  key: 5,
  class: "text-muted"
}
const _hoisted_63 = {
  key: 6,
  class: "text-muted"
}
const _hoisted_64 = {
  key: 0,
  class: "col-12 col-md-2 mt-3 mt-md-0 pull-right"
}
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Ambil Data ")
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Judul Berita", -1))
const _hoisted_73 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { class: "row mb-6" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Nama Akun", -1))
const _hoisted_78 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = { class: "row mb-6" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tanggal Berita"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Tanggal dalam GMT+7"
  })
], -1))
const _hoisted_83 = { class: "col-12 col-sm-10 col-lg-5 fv-row" }
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Like", -1))
const _hoisted_88 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Komentar", -1))
const _hoisted_93 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_94 = { class: "fv-plugins-message-container" }
const _hoisted_95 = { class: "fv-help-block" }
const _hoisted_96 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Repost", -1))
const _hoisted_98 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_99 = { class: "fv-plugins-message-container" }
const _hoisted_100 = { class: "fv-help-block" }
const _hoisted_101 = {
  key: 4,
  class: "row mb-6"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Share", -1))
const _hoisted_103 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_104 = { class: "fv-plugins-message-container" }
const _hoisted_105 = { class: "fv-help-block" }
const _hoisted_106 = {
  key: 5,
  class: "row mb-6"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Viewer", -1))
const _hoisted_108 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_109 = { class: "fv-plugins-message-container" }
const _hoisted_110 = { class: "fv-help-block" }
const _hoisted_111 = {
  key: 6,
  class: "row mb-6"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Favorite", -1))
const _hoisted_113 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_114 = { class: "fv-plugins-message-container" }
const _hoisted_115 = { class: "fv-help-block" }
const _hoisted_116 = {
  key: 7,
  class: "row mb-6"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Quote", -1))
const _hoisted_118 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_119 = { class: "fv-plugins-message-container" }
const _hoisted_120 = { class: "fv-help-block" }
const _hoisted_121 = {
  key: 8,
  class: "row mb-6"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Reply", -1))
const _hoisted_123 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_124 = { class: "fv-plugins-message-container" }
const _hoisted_125 = { class: "fv-help-block" }
const _hoisted_126 = {
  key: 9,
  class: "row mb-6"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Jumlah Retweet", -1))
const _hoisted_128 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_129 = { class: "fv-plugins-message-container" }
const _hoisted_130 = { class: "fv-help-block" }
const _hoisted_131 = { class: "row mb-6" }
const _hoisted_132 = { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }
const _hoisted_133 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_134 = { class: "fv-plugins-message-container" }
const _hoisted_135 = { class: "fv-help-block" }
const _hoisted_136 = { class: "row mb-6" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label fw-bold fs-6" }, "Emotion", -1))
const _hoisted_138 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { class: "col-6 col-sm-4 col-md-2" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-meh-blank fs-2x text-primary" })
], -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Netral")
], -1))
const _hoisted_143 = [
  _hoisted_141,
  _hoisted_142
]
const _hoisted_144 = { class: "col-6 col-sm-4 col-md-2" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-grin-squint text-success fs-2x" })
], -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Senang")
], -1))
const _hoisted_147 = [
  _hoisted_145,
  _hoisted_146
]
const _hoisted_148 = { class: "col-6 col-sm-4 col-md-2 mt-3 mt-sm-0" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-flushed text-warning fs-2x" })
], -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Takut")
], -1))
const _hoisted_151 = [
  _hoisted_149,
  _hoisted_150
]
const _hoisted_152 = { class: "col-6 col-sm-4 col-md-2 mt-3 mt-sm-0" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-sad-tear text-complete fs-2x" })
], -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Sedih")
], -1))
const _hoisted_155 = [
  _hoisted_153,
  _hoisted_154
]
const _hoisted_156 = { class: "col-6 col-sm-4 col-md-2 mt-3 mt-sm-0" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-angry text-danger fs-2x" })
], -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Marah")
], -1))
const _hoisted_159 = [
  _hoisted_157,
  _hoisted_158
]
const _hoisted_160 = { class: "fv-plugins-message-container" }
const _hoisted_161 = { class: "fv-help-block" }
const _hoisted_162 = { class: "row mb-6" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label fw-bold fs-6" }, "Sentimen", -1))
const _hoisted_164 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_165 = { class: "row" }
const _hoisted_166 = { class: "col-6 col-sm-4 col-md-2" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-smile fs-2x text-success" })
], -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Positif")
], -1))
const _hoisted_169 = [
  _hoisted_167,
  _hoisted_168
]
const _hoisted_170 = { class: "col-6 col-sm-4 col-md-2" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-meh text-primary fs-2x" })
], -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Netral")
], -1))
const _hoisted_173 = [
  _hoisted_171,
  _hoisted_172
]
const _hoisted_174 = { class: "col-6 col-sm-4 col-md-2 mt-3 mt-sm-0" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-frown text-danger fs-2x" })
], -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Negatif")
], -1))
const _hoisted_177 = [
  _hoisted_175,
  _hoisted_176
]
const _hoisted_178 = { class: "fv-plugins-message-container" }
const _hoisted_179 = { class: "fv-help-block" }
const _hoisted_180 = { class: "row mb-6" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 col-sm-2 col-lg-2 col-form-label required fw-bold fs-6" }, "Konten Berita", -1))
const _hoisted_182 = { class: "col-12 col-sm-10 col-lg-10 fv-row" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1))
const _hoisted_184 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")
const _hoisted_185 = [
  _hoisted_183,
  _hoisted_184
]
const _hoisted_186 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_187 = { class: "fv-help-block" }
const _hoisted_188 = { class: "text-danger" }
const _hoisted_189 = { class: "row" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, null, -1))
const _hoisted_191 = { class: "col-md-10" }
const _hoisted_192 = { class: "card-footer d-flex py-6" }
const _hoisted_193 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton1",
  class: "btn btn-success btn-sm"
}
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan Data ", -1))
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_196 = [
  _hoisted_194,
  _hoisted_195
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _cache[34] || (_cache[34] = ($event: any) => (_ctx.saveChanges1())),
        "validation-schema": _ctx.MediaSosialFormValidator
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "youtube",
                      id: "youtube_radio",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc007.svg" })
                      ]),
                      _hoisted_12
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "instagram",
                      id: "instagram_radio",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc005.svg" })
                      ]),
                      _hoisted_16
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "twitter",
                      id: "twitter_radio",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc006.svg" })
                      ]),
                      _hoisted_20
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "facebook",
                      id: "facebook",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc004.svg" })
                      ]),
                      _hoisted_24
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "tiktok",
                      id: "tiktok",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc008.svg" })
                      ]),
                      _hoisted_28
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "linkedin",
                      id: "linkedin",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/linkedin.svg" })
                      ]),
                      _hoisted_32
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "review",
                      id: "review",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc002.svg" })
                      ]),
                      _hoisted_36
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      class: "btn-check",
                      name: "source",
                      value: "threads",
                      id: "threads",
                      modelValue: _ctx.MediaSosialForm.source,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.MediaSosialForm.source) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc011.svg" })
                      ]),
                      _hoisted_40
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_ErrorMessage, { name: "source" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.MediaSosialForm.source == 'linkedin' ? 'col-12' : 'col-12 col-md-10')
                  }, [
                    _createElementVNode("div", _hoisted_47, [
                      (_ctx.MediaSosialForm.source == 'instagram')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, "https://www.instagram.com/p/"))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'youtube')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, "https://www.youtube.com/watch?v="))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'twitter')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.twitterUrl), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "url",
                        class: "form-control form-control-lg",
                        placeholder: "ID URL Berita",
                        modelValue: _ctx.shortUrl,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.shortUrl) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    (
                    _ctx.MediaSosialForm.source != 'facebook' &&
                    _ctx.MediaSosialForm.source != 'tiktok' &&
                    _ctx.MediaSosialForm.source != 'linkedin' &&
                    _ctx.MediaSosialForm.source != 'threads'
                  )
                      ? (_openBlock(), _createElementBlock("small", _hoisted_51, _hoisted_54))
                      : _createCommentVNode("", true),
                    _createElementVNode("small", _hoisted_55, [
                      _hoisted_56,
                      (_ctx.MediaSosialForm.source == 'instagram')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, "ID berita merupakan string bagian terakhir setelah URL \"https://www.instagram.com/p/\""))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'youtube')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, "ID berita merupakan string bagian terakhir setelah URL \"https://www.youtube.com/watch?v=\""))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'twitter')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, "ID berita merupakan string bagian terakhir setelah URL \"" + _toDisplayString(_ctx.twitterUrl) + "\"", 1))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'facebook')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, "URL berita merupakan URL postingan dengan prefix posts, reel, videos atau watch."))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'tiktok')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, "URL berita didapatkan ketika menekan tombol bagikan pada postingan."))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'linkedin')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, "URL berita didapatkan ketika menekan tombol bagikan pada postingan."))
                        : _createCommentVNode("", true),
                      (_ctx.MediaSosialForm.source == 'threads')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, "URL berita lengkap postingan Threads. Contoh: https://www.threads.com/@username/post/ID_POSTINGAN"))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  (_ctx.MediaSosialForm.source != 'linkedin')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-lg btn-block w-100",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.getContentUrl && _ctx.getContentUrl(...args))),
                          ref: "getDataButton1",
                          disabled: _ctx.shortUrl == ''
                        }, _hoisted_68, 8, _hoisted_65)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_ErrorMessage, { name: "url" })
                  ])
                ])
              ])
            ]),
            (_ctx.MediaSosialForm.source == 'youtube')
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "title",
                      class: "form-control form-control-lg",
                      placeholder: "Judul Berita",
                      modelValue: _ctx.MediaSosialForm.title,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.MediaSosialForm.title) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_ErrorMessage, { name: "title" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_76, [
              _hoisted_77,
              _createElementVNode("div", _hoisted_78, [
                _createVNode(_component_Field, {
                  type: "text",
                  name: "account",
                  class: "form-control form-control-lg",
                  placeholder: "Nama Akun",
                  modelValue: _ctx.MediaSosialForm.account,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.MediaSosialForm.account) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createVNode(_component_ErrorMessage, { name: "account" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_Field, { name: "date" }, {
                  default: _withCtx(({ handleBlur, handleChange }) => [
                    _createVNode(_component_el_form, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "dueDate",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"100% !important"},
                              onBlur: handleBlur,
                              onChange: handleChange,
                              modelValue: _ctx.MediaSosialForm.date,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.MediaSosialForm.date) = $event)),
                              placeholder: "Tanggal Berita",
                              format: "YYYY-MM-DD HH:mm:ss",
                              name: "date",
                              type: "datetime"
                            }, null, 8, ["onBlur", "onChange", "modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_ErrorMessage, { name: "date" })
                  ])
                ])
              ])
            ]),
            (_ctx.MediaSosialForm.source != 'twitter')
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  _hoisted_87,
                  _createElementVNode("div", _hoisted_88, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "like",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Like",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.like,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.like) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _createVNode(_component_ErrorMessage, { name: "like" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.MediaSosialForm.source != 'twitter')
              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                  _hoisted_92,
                  _createElementVNode("div", _hoisted_93, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "comment",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Komentar",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.comment,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.comment) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createVNode(_component_ErrorMessage, { name: "comment" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.MediaSosialForm.source == 'threads')
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _hoisted_97,
                  _createElementVNode("div", _hoisted_98, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "repost",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Repost",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.repost,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.repost) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createVNode(_component_ErrorMessage, { name: "repost" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.MediaSosialForm.source == 'threads')
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", _hoisted_103, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "share",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Share",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.share,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.share) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createVNode(_component_ErrorMessage, { name: "share" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.MediaSosialForm.source == 'youtube')
              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                  _hoisted_107,
                  _createElementVNode("div", _hoisted_108, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "view",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Viewer",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.view,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.view) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _createVNode(_component_ErrorMessage, { name: "view" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.MediaSosialForm.source != 'instagram' &&
            _ctx.MediaSosialForm.source != 'facebook' &&
            _ctx.MediaSosialForm.source != 'tiktok' &&
            _ctx.MediaSosialForm.source != 'threads'
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                  _hoisted_112,
                  _createElementVNode("div", _hoisted_113, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "favorite",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Favorit",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.favorite,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.favorite) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createVNode(_component_ErrorMessage, { name: "favorite" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.MediaSosialForm.source == 'twitter')
              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                  _hoisted_117,
                  _createElementVNode("div", _hoisted_118, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "quote",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Quote",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.quote,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.quote) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("div", _hoisted_120, [
                        _createVNode(_component_ErrorMessage, { name: "quote" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.MediaSosialForm.source == 'twitter')
              ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                  _hoisted_122,
                  _createElementVNode("div", _hoisted_123, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "reply",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Reply",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.reply,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.reply) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("div", _hoisted_125, [
                        _createVNode(_component_ErrorMessage, { name: "reply" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.MediaSosialForm.source == 'twitter')
              ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                  _hoisted_127,
                  _createElementVNode("div", _hoisted_128, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "retweet",
                      class: "form-control form-control-lg",
                      placeholder: "Jumlah Retweet",
                      modelValue: _ctx.MediaSosialForm.engagement_detail.rt,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.MediaSosialForm.engagement_detail.rt) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _createVNode(_component_ErrorMessage, { name: "retweet" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("label", _hoisted_132, "Jumlah " + _toDisplayString(_ctx.MediaSosialForm.source == "youtube"
                  ? "Subscribers"
                  : "Followers"), 1),
              _createElementVNode("div", _hoisted_133, [
                _createVNode(_component_Field, {
                  type: "number",
                  name: "followers",
                  class: "form-control form-control-lg",
                  placeholder: "Jumlah Subscribers",
                  modelValue: _ctx.MediaSosialForm.followers,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.MediaSosialForm.followers) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _createVNode(_component_ErrorMessage, { name: "followers" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_136, [
              _hoisted_137,
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_netral",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setEmotion('0')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.emotion == '0' ? 'cek-active' : '']),
                      for: "emotion_netral"
                    }, _hoisted_143, 2)
                  ]),
                  _createElementVNode("div", _hoisted_144, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_senang",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.setEmotion('1')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.emotion == '1' ? 'cek-active' : '']),
                      for: "emotion_senang"
                    }, _hoisted_147, 2)
                  ]),
                  _createElementVNode("div", _hoisted_148, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_takut",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.setEmotion('2')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.emotion == '2' ? 'cek-active' : '']),
                      for: "emotion_takut"
                    }, _hoisted_151, 2)
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_sedih",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.setEmotion('3')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.emotion == '3' ? 'cek-active' : '']),
                      for: "emotion_sedih"
                    }, _hoisted_155, 2)
                  ]),
                  _createElementVNode("div", _hoisted_156, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_marah",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.setEmotion('4')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.emotion == '4' ? 'cek-active' : '']),
                      for: "emotion_marah"
                    }, _hoisted_159, 2)
                  ]),
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("div", _hoisted_161, [
                      _createVNode(_component_ErrorMessage, { name: "emotion" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_162, [
              _hoisted_163,
              _createElementVNode("div", _hoisted_164, [
                _createElementVNode("div", _hoisted_165, [
                  _createElementVNode("div", _hoisted_166, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "sentiment",
                      id: "sentiment_positif",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.setSentiment('1')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.sentiment == '1' ? 'cek-active' : ''
                      ]),
                      for: "sentiment_positif"
                    }, _hoisted_169, 2)
                  ]),
                  _createElementVNode("div", _hoisted_170, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "sentiment",
                      id: "sentiment_netral",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setSentiment('0')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.sentiment == '0' ? 'cek-active' : ''
                      ]),
                      for: "sentiment_netral"
                    }, _hoisted_173, 2)
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "sentiment",
                      id: "sentiment_negatif",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.setSentiment('-1')))
                    }),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center", _ctx.MediaSosialForm.sentiment == '-1' ? 'cek-active' : ''
                      ]),
                      for: "sentiment_negatif"
                    }, _hoisted_177, 2)
                  ]),
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _createVNode(_component_ErrorMessage, { name: "sentiment" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_180, [
              _hoisted_181,
              _createElementVNode("div", _hoisted_182, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  rows: "10",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.MediaSosialForm.content) = $event)),
                  placeholder: "Konten berita..."
                }, "\n              ", 512), [
                  [_vModelText, _ctx.MediaSosialForm.content]
                ]),
                _createElementVNode("a", {
                  size: "small",
                  class: "btn btn-sm btn-primary mt-5",
                  type: "primary",
                  onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.convertText && _ctx.convertText(...args)))
                }, _hoisted_185),
                (_ctx.contentError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                      _createElementVNode("div", _hoisted_187, [
                        _createElementVNode("div", _hoisted_188, _toDisplayString(_ctx.contentError), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_189, [
            _hoisted_190,
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("div", _hoisted_192, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger btn-sm me-auto",
                  style: {"margin-left":"-1rem"},
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.router.go(-1)))
                }, " Batal "),
                _createElementVNode("button", _hoisted_193, _hoisted_196, 512)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}